import { Mail } from 'lucide-react';

export function DashboardFooter() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="py-2">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <span>© {new Date().getFullYear()} SafeIdea LLC. All rights reserved.</span>
              <a
                href="mailto:info@safeidea.ai"
                className="flex items-center gap-1 hover:text-primary"
              >
                <Mail className="h-3 w-3" />
                Support
              </a>
            </div>
            <div className="flex items-center gap-3 text-xs text-muted-foreground/70">
              <a href="/help" className="hover:text-primary">
                Help
              </a>
              <a href="/privacy" className="hover:text-primary">
                Privacy
              </a>
              <a href="/terms" className="hover:text-primary">
                Terms
              </a>
              <span
                title={`Version: ${import.meta.env.VITE_APP_VERSION || 'dev'}${
                  import.meta.env.VITE_BUILD_TYPE ? ` (${import.meta.env.VITE_BUILD_TYPE})` : ''
                }${
                  import.meta.env.VITE_BUILD_DATE || new Date().toISOString()
                    ? `\nBuilt: ${new Date(import.meta.env.VITE_BUILD_DATE || new Date().toISOString()).toLocaleString()}`
                    : ''
                }${
                  import.meta.env.VITE_BUILD_COMMIT ||
                  `dev-${Math.random().toString(36).substring(2, 9)}`
                    ? `\nCommit: ${(import.meta.env.VITE_BUILD_COMMIT || `dev-${Math.random().toString(36).substring(2, 9)}`).slice(0, 7)}`
                    : ''
                }`}
                className="cursor-help"
              >
                v{import.meta.env.VITE_APP_VERSION || 'dev'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
